/**
 * Vuex getters for the "groupchannel" module.
 *
 * Thin state accessors exposing the group channel data, channel list, and
 * following list/count as-is.
 */
export default {
  getGroupChannelData: state => state.groupChannelData,
  getGroupChannelsList: state => state.groupChannelsList,
  getFollowingList: state => state.followingList,
  getFollowingCount: state => state.followingCount,
};
